<template>
  <el-container>
    <div class="t_neiban">
      <div class="t_b1banpic">
        <img src="../assets/image/coroprate1.png" alt="招标公示">
      </div>
      <div class="nesc_cont1360 nesc_pos_bot">
        <h2 class="nesc_inban_title animate__animated animate__fadeInDown">{{ $t('lang.bidAnnouncement') }}</h2>
      </div>
    </div>
    <div class="nesc_cont1360">
      <div class="newList" v-for="item in talentsList" :key="item.NewsInfoId" >
        <div class="content">
          <div class="leftTime">
            <span class="newTime">{{item.CreateTime.split('-')[1] + '-' + item.CreateTime.split('-')[2]}}</span>
            <i class="newIcon el-icon-right"></i>
          </div>
          <div class="rightC">
            <h3 class="newTitle">
              <span class="newTitleLink">
                {{item.Title}}
              </span>
            </h3>
            <article class="newMs">
              {{item.Summary}}
            </article>
          </div>
          <el-button v-if="item.AttachmentUrl" @click="download(item.AttachmentUrl)">附件</el-button>
        </div>
      </div>
    </div>
    <el-pagination :class="{hidePreBtn: curPage == 1, hideNextBtn: curPage == totalPage}" class="pcfy flex-row-center" hide-on-single-page :total="total" :page-size="pageSize" layout="prev, pager, next" @current-change="getNews" @prev-click="getNews" @next-click="getNews" />
    <el-row class="phfy" type="flex" justify="space-around">
      <el-col :span="8">
        <a v-if="curPage> 1 " @click="getNews(curPage - 1)">{{ $t('lang.previous') }}</a>
      </el-col>
      <el-col :span="8">
        <a v-if="curPage < totalPage" @click="getNews(curPage + 1)">{{ $t('lang.next') }}</a>
      </el-col>
    </el-row>
  </el-container>
</template>

<script>
export default {
  name: 'Talent',
  data: () => {
    return {
      talentsList: [],
      pageSize: 10,
      curPage: 1,
      loading: !0,
      total: 0,
      totalPage: 0
    }
  },

  mounted() {
    this.getNews(1)
  },

  methods: {
    getNews(e) {
      e && (this.curPage = e)
      this.$http.post(this.isDevelop ? '/NewsList' : '/api/NewsService/NewsList1', { page: e, limit: this.pageSize }).then(
          (responseNews) => {
            window.scrollTo(0, 0)
            responseNews.statusText == 'OK' && responseNews.data.data.length > 0 &&
            (
                this.talentsList = responseNews.data.data || [], this.total = parseInt(responseNews.data.count),
                    this.loading = !1,
                    this.totalPage = parseInt(responseNews.data.count / this.pageSize) + 1
            )
          }
      ).catch(function() {
        this.talentsList = []
      })
    },
    download(url) {
      console.log(this.domainUrl + url)
      window.open(this.domainUrl + url)
    }
  }
}
</script>

<style lang="scss">
@import "../assets/scss/pagination";
</style>
<style scoped lang="scss">
img {
  vertical-align: middle;
}
.t_neiban {
  position: relative;
}
.t_b1banpic {
  width: 100%;
}
.t_b1banpic img {
  width: 100%;
  height: 300px;
}

.nesc_pos_bot {
  position: absolute;
  bottom: auto;
  left: 50%;
  top: 50% ;
  transform: translate(-50%, -50%) !important;
}

.nesc_inban_title {
  font-size: 72px;
  line-height: 1.45;
  font-weight: bold;
  font-family: "OPPOSans2_En_design-Heavy", "OPPOSans2_En_design-Regular", "微软雅黑", Arial, "PingFangSC-Light", "Helvetica Neue", Helvetica, "Microsoft Yahei", "Hiragino Sans GB", tahoma, SimSun, sans-serif;
  color: rgba(87, 87, 87, 0.8);
}
.nesc_cont1360 {
  margin: 50px auto;
}
.newList {
  padding: 30px;
  border-bottom: 1px solid #DDD;
  &:last-of-type {
    border-bottom: none;
  }
  background: #fff;
  margin-bottom: 20px;
  .content {
    display: flex;
    flex: 1;
  }
  .leftTime {
    width: 100px;
    position: relative;
    .newTime {
      display: block;
      color: #999;
      font-size: 1.5rem;
      font-weight: normal;
      margin: 0px 0 30px;
      transition: all .5s ease;
    }
  }
  .rightC {
    padding: 0 30px 0 60px;
  }
  .rightC {
    position: relative;
    flex:1;
    transition: all .5s ease;
  }
  .rightC::before {
    content: '';
    position: absolute;
    left: 0px;
    top: 1rem;
    display: block;
    width: 40px;
    height: 1px;
    background: #aaa;
    transition: all .5s ease;
  }
  .newTitleLink {
    display: block;
    width: 100%;
    font-size: 1rem;
    color: #000;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .newIcon {
    font-size: 20px;
    font-weight: bold;
    padding: 6px 11px;
    border: 1px solid transparent;
    transition: all .5s ease;
    color: #ccc;
  }

  .newTitle {
    margin-bottom: 10px;
  }

  .newMs {
    line-height: 24px;
    font-size: 0.875rem;
    color: #999;
    transition: 600ms;
  }
  ::v-deep .el-button {
    height: 40px;
    border: 1px solid  rgb(234, 104, 40);
    background: #ffffff;
    color: rgb(234, 104, 40);
  }
}

.newList:hover .newTitleLink {
  color: rgb(234, 104, 40);
}

.newList:hover .rightC::before {
  width: 60px;
}

.newList:hover .rightC {
  padding-left: 80px;
}

.newList:hover .newTime {
  color: #333;
}

.newList:hover .newIcon {
  margin-top: 10px;
  background: rgb(234, 104, 40);
  color: #ffffff;
}

.newList:hover button {
  background: rgb(234, 104, 40);
  color: #ffffff;
  border: none;
}

@media screen and (max-width: 1680px) {
  .nesc_inban_title {
    font-size: 64px;
  }
}

@media screen and (max-width: 1440px) {
  .nesc_inban_title {
    font-size: 48px;
  }
}

@media only screen and (max-width: 768px) {
  .t_b1banpic {
    img {
      height: 150px;
    }
  }
  .nesc_inban_title {
    font-size: 32px;
  }
  .nesc_cont1360 {
    margin: 2px auto;
    padding: 0 2px;
  }
  .newList {
    padding: 10px 8px;
  }
  .leftTime > .newIcon{
    display: none;
  }
  .content {
    display: flex;
    flex-direction: column;
    .rightC {
      padding: 0 0;
    }
    .rightC::before {
      content: none;
    }
  }
  .el-button {
    margin-top: 20px;
  }
}

</style>
